import * as AdminController from './AdminController';
import * as GoodsController from './GoodsController';
import * as CategoryController from './CategoryController';
import * as CommonController from './CommonController';
import * as CarouselController from './CarouselController';
import * as IntroductionController from './IntroductionController';

export default {
  AdminController,
  GoodsController,
  CommonController,
  CarouselController,
  CategoryController,
  IntroductionController,
};
